import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { SolicitacaoAuxSaudeService } from 'app/service/solicitacao-aux-saude/solicitacao-aux-saude.service';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { ModalRejeitarComponent } from 'app/components/modal-rejeitar/modal-rejeitar.component';
import { ToastrService } from 'ngx-toastr';
import { IdentityStorage } from "../../auth/_models/identity.storage";

@Component({
  selector: 'app-visualizar-solicitacao',
  templateUrl: './visualizar-solicitacao.component.html',
  styleUrls: ['./visualizar-solicitacao.component.sass']
})
export class VisualizarSolicitacaoComponent implements OnInit {
  form: FormGroup = null;
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = ['nomeCompleto', 'cpf', 'dependente', 'tipoPlano', 'nomePlano', 'valor', 'acoes']
  solicitacaoId: number = null;
  solicitacao: any;
  totalElements: number;
  private permissionMap = {
    'CPREV_USER': '',
    'CPREV_ADMIN': '',
    'SEGESP_PRE_ADMIN': '/pre-segesp',
    'AEP_PRE_ADMIN': '/pre-aep',
    'SEGESP_ADMIN': '/segesp',
    'AEP_ADMIN': '/aep'
  };
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private solicitacaoAuxSaudeService: SolicitacaoAuxSaudeService,
    private router: Router,
    private location: Location,
    public dialog: MatDialog,
    private toasterService: ToastrService,
    public identityStorage: IdentityStorage,) { }

  ngOnInit(): void {
    this.solicitacaoId = this.extractIdFromUrl();
    this.createForm();
    this.loadDados(this.solicitacaoId);
  }

  extractIdFromUrl(): number {
    return this.route.snapshot.params.id?parseInt(this.route.snapshot.params.id): null;
  }

  loadDados(id: number) {
    this.solicitacaoAuxSaudeService.getVisualizarSolicitacao(id).subscribe((result) => {
      this.solicitacao = result;
      this.fillForm(result);
    })
  }

  fillForm(data) {
    const campos = ['nome', 'cargo', 'vinculo', 'telefone', 'celular', 'cpf', 'dataNascimento']
    campos.forEach(campo => {
      this.form.get(campo).setValue(data.dadosBasicosServidor[campo]);
    });
    this.dataSource.data = data.dependentes.map(
      element => { return { ...element, dependente: "Sim" } }
    ).concat(data.titular.map(element => { return { ...element, dependente: "Não" } }));
    this.totalElements = this.dataSource.data.length;
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      //Dados Pessoais
      nome: [{ value: null, disabled: true }],
      cargo: [{ value: null, disabled: true }],
      vinculo: [{ value: null, disabled: true }],
      telefone: [{ value: null, disabled: true }],
      celular: [{ value: null, disabled: true }],
      cpf: [null],
      dataNascimento: [null],
    });
  }

  detalhesSolicitacao(id: number) {
    this.router.navigate([`detalhes-solicitacao/${this.solicitacaoId}/${id}`])
  }

  voltar() {
    this.location.back();
  }

  openDialogExcluir(): void {
    this.dialog.open(ModalRejeitarComponent, {
      width: '800px',
      data: {
        titulo: "Justificativa da Recusa",
        mensagem: "Por favor, selecione e justifique o motivo da rejeição",
        botaoOk: "Salvar",
        botaoCancelar: "Cancelar",
        acaoOk: (data) => {
          this.submit(data.motivo, data.justificativa)
        }
      }
    });
  }

  submit(tipoRejeicao?: number, justificativa?: string) {
    const data = {
      status: tipoRejeicao ? 3 : 4,
      observacao: justificativa,
      tipoRejeicao: tipoRejeicao,
      formSoliAuxSaudeId: this.solicitacaoId,
      processoFinalizado: false
    }

    const mapPathTypeUser = this.identityStorage.getUserAuthData().roles
                                    .filter( role => this.permissionMap[role.nome])
                                    .map( filtered => this.permissionMap[filtered.nome])

    this.solicitacaoAuxSaudeService.salvarAvalicao(data, mapPathTypeUser[0]).subscribe((result) => {
      this.toasterService.success("Avaliação salva com sucesso")
      this.voltar()
    }, error => {
      this.toasterService.error(error.error.message)
    })
  }
}
